var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableflowLogoShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M20.9956 7.20107H5.70371C4.45807 7.20107 3.44829 8.21087 3.44829 9.45651V10.5391C3.44829 11.7848 4.45807 12.7946 5.70371 12.7946H20.9956C22.2412 12.7946 23.251 11.7848 23.251 10.5391V9.45651C23.251 8.21087 22.2412 7.20107 20.9956 7.20107Z",
    fill: "#5F2EE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.5142 14.3058H9.22239C7.97675 14.3058 6.96696 15.3156 6.96696 16.5612V17.6438C6.96696 18.8894 7.97675 19.8993 9.22239 19.8993H24.5142C25.76 19.8993 26.7696 18.8894 26.7696 17.6438V16.5612C26.7696 15.3156 25.76 14.3058 24.5142 14.3058Z",
    fill: "#5F2EE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1086 0.0740967H2.81673C1.57109 0.0740967 0.561295 1.08389 0.561295 2.32953V3.41214C0.561295 4.65778 1.57109 5.66759 2.81673 5.66759H18.1086C19.3542 5.66759 20.364 4.65778 20.364 3.41214V2.32953C20.364 1.08389 19.3542 0.0740967 18.1086 0.0740967Z",
    fill: "#5F2EE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4097 7.20107H5.70371C4.45807 7.20107 3.44829 8.21087 3.44829 9.45651V10.5391C3.44829 11.7848 4.45807 12.7946 5.70371 12.7946H14.4097C15.6553 12.7946 16.6651 11.7848 16.6651 10.5391V9.45651C16.6651 8.21087 15.6553 7.20107 14.4097 7.20107Z",
    fill: "#5F2EE5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.32 14.3058H9.22239C7.97675 14.3058 6.96696 15.3156 6.96696 16.5612V17.6438C6.96696 18.8894 7.97675 19.8993 9.22239 19.8993H11.32C12.5656 19.8993 13.5754 18.8894 13.5754 17.6438V16.5612C13.5754 15.3156 12.5656 14.3058 11.32 14.3058Z",
    fill: "#5F2EE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableflowLogoShort);
export default __webpack_public_path__ + "static/media/tableflow-logo-short.fa8befe1e29f019a52ed880d014f6438.svg";
export { ForwardRef as ReactComponent };